import { MOCK_CONTACT } from './MockContact'

export const MOCK_OPPORTUNITIES = [
  {
    _created_at: '2025-04-07T07:23:15.620Z',
    _id: 'bc6609ed-6b0c-4ad3-b6d4-42e72b68521f',
    _org: 'test-org',
    _purpose: ['70df3680-aee0-4cc0-89b3-0df016a23efd'],
    _schema: 'opportunity',
    _tags: ['Wärmepumpe'],
    _title: 'OP-102 - Wärmepumpe (Leadgenerierung)',
    _updated_at: '2025-04-07T07:23:20.830Z',
    amount: 15000,
    amount_currency: 'EUR',
    amount_decimal: '150.00',
    close_date: '2025-06-30',
    customer: [MOCK_CONTACT],
    description: 'Heat pump installation opportunity for residential customer',
    opportunity_number: 'OP-102',
    opportunity_title: 'Wärmepumpe (Leadgenerierung)',
    probability: 75,
    stage: 'proposal',
    status: 'open',
    type: 'new_business'
  },
  {
    _created_at: '2025-03-22T14:18:42.345Z',
    _id: 'd7e8f9a0-b1c2-3456-789d-ef0123456789',
    _org: 'test-org',
    _purpose: ['70df3680-aee0-4cc0-89b3-0df016a23efd'],
    _schema: 'opportunity',
    _tags: ['Solar'],
    _title: 'OP-103 - Solar Panel Installation',
    _updated_at: '2025-05-15T10:30:25.678Z',
    amount: 25000,
    amount_currency: 'EUR',
    amount_decimal: '250.00',
    close_date: '2025-08-15',
    customer: [MOCK_CONTACT],
    description: 'Solar panel system installation for commercial building',
    opportunity_number: 'OP-103',
    opportunity_title: 'Solar Panel Installation',
    probability: 60,
    stage: 'negotiation',
    status: 'open',
    type: 'new_business'
  },
  {
    _created_at: '2025-02-10T09:45:18.234Z',
    _id: 'e3f4a5b6-c7d8-9012-3456-789abcdef012',
    _org: 'test-org',
    _purpose: ['70df3680-aee0-4cc0-89b3-0df016a23efd'],
    _schema: 'opportunity',
    _tags: ['Maintenance'],
    _title: 'OP-104 - Annual Maintenance Contract',
    _updated_at: '2025-04-20T16:22:45.567Z',
    amount: 5000,
    amount_currency: 'EUR',
    amount_decimal: '50.00',
    close_date: '2025-07-01',
    customer: [MOCK_CONTACT],
    description: 'Annual maintenance service contract renewal',
    opportunity_number: 'OP-104',
    opportunity_title: 'Annual Maintenance Contract',
    probability: 90,
    stage: 'closed_won',
    status: 'closed',
    type: 'existing_business'
  },
  {
    _created_at: '2025-01-18T11:30:22.123Z',
    _id: 'f5a6b7c8-d9e0-1234-5678-90abcdef1234',
    _org: 'test-org',
    _purpose: ['70df3680-aee0-4cc0-89b3-0df016a23efd'],
    _schema: 'opportunity',
    _tags: ['EV Charging'],
    _title: 'OP-105 - EV Charging Station',
    _updated_at: '2025-03-25T13:45:18.890Z',
    amount: 8000,
    amount_currency: 'EUR',
    amount_decimal: '80.00',
    close_date: '2025-09-30',
    customer: [MOCK_CONTACT],
    description: 'Electric vehicle charging station installation',
    opportunity_number: 'OP-105',
    opportunity_title: 'EV Charging Station',
    probability: 45,
    stage: 'qualification',
    status: 'open',
    type: 'new_business'
  },
  {
    _created_at: '2025-05-12T08:15:45.678Z',
    _id: 'a9b8c7d6-e5f4-3210-9876-543210fedcba',
    _org: 'test-org',
    _purpose: ['70df3680-aee0-4cc0-89b3-0df016a23efd'],
    _schema: 'opportunity',
    _tags: ['Energy Audit'],
    _title: 'OP-106 - Energy Efficiency Audit',
    _updated_at: '2025-06-05T12:20:30.345Z',
    amount: 3500,
    amount_currency: 'EUR',
    amount_decimal: '35.00',
    close_date: '2025-10-15',
    customer: [MOCK_CONTACT],
    description:
      'Comprehensive energy efficiency audit for industrial facility',
    opportunity_number: 'OP-106',
    opportunity_title: 'Energy Efficiency Audit',
    probability: 80,
    stage: 'proposal',
    status: 'open',
    type: 'new_business'
  },
  {
    _created_at: '2025-04-28T16:45:12.456Z',
    _id: 'b2c3d4e5-f6a7-8901-2345-6789abcdef01',
    _org: 'test-org',
    _purpose: ['70df3680-aee0-4cc0-89b3-0df016a23efd'],
    _schema: 'opportunity',
    _tags: ['Smart Home'],
    _title: 'OP-107 - Smart Home Integration',
    _updated_at: '2025-06-12T14:35:28.789Z',
    amount: 12000,
    amount_currency: 'EUR',
    amount_decimal: '120.00',
    close_date: '2025-11-20',
    customer: [MOCK_CONTACT],
    description: 'Complete smart home automation system integration',
    opportunity_number: 'OP-107',
    opportunity_title: 'Smart Home Integration',
    probability: 55,
    stage: 'needs_analysis',
    status: 'open',
    type: 'new_business'
  }
]
